module.exports = __webpack_public_path__ + "prize-4.c92d444b.png";